<template>
	<div class="main-container" v-loading="true">
		<div class="logo"></div>
		<div class="title">加载中</div>
		<!-- <div class="title">对不起，没有找到您要浏览的页面</div>
		<div class="go-back-button" @click="goBack">返回上页</div> -->
	</div>
</template>

<script>
	export default{
		name: "err_404",
		methods:{
			goBack(){
				this.$router.back()
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	@import "~@/assets/styles/_handle.scss";
	
	.main-container{
		width: 100%;
		height: 100%;
		box-sizing: border-box;
		padding-top: 100px;
		display: flex;
		flex-direction: column;
		align-items: center;
		align-content: center;
		box-sizing: border-box;
		@include background_color("err404_background-color");
		
		.logo{
			// @include background_image("err404_logo");
			background-repeat: no-repeat;
			background-size: 100% 100%;
			width: 100%;
			height: 210px;
		}
		
		.title{
			@include font_family("font_family");
			font-size: 40px;
			@include font_color("error_title_font_color");
			line-height: 40px;
			margin-top: 96px;
			height: 40px;
			width: auto;
		}
		
		.go-back-button{
			line-height: 32px;
			font-size: 32px;
			height: 80px;
			width: 240px;
			display: flex;
			justify-content: center;
			align-items: center;
			align-content: center;
			font-family: hansan;
			@include font_color("err404_button_font-color");
			@include background_color("err404_button_bg-color");
			border-radius: 20px;
			margin-top: 80px;
			cursor: pointer;
			
			&:hover{
				opacity: 0.4;
			}
		}
	}
</style>
